import { EmployeeType } from "winslow-core";
import Modal from "../../shared/Modal";
import "./ModalConfirmChangeType.css";
import { Button } from "../../../ds2/components";

type ModalConfirmChangeTypeProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const ModalConfirmChangeType = ({
  isOpen,
  onClose,
  onContinue,
}: ModalConfirmChangeTypeProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={true}
        allowClickout={true}
    >
        <div id="modal-confirm-change-type">
            <div className="modal-confirm-change-type-title">
                Change Worker Type?
            </div>

            <div className="modal-confirm-change-type-content">
                <p>
                    Changing the worker type may result in the loss of some information that maybe be irriversible.
                    Do you wish to continue?
                </p>
            </div>

            <div className="modal-confirm-change-type-buttons">
                <Button
                    variant="secondary"
                    onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={() => onContinue()}>
                    Continue
                </Button>
                
                {/* <button
                    className="button-cancel"
                    onClick={onClose}
                >
                    Cancel
                </button>
                <button
                    className="button-save"
                    onClick={() => onContinue()}
                >
                    Continue
                </button> */}
            </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalConfirmChangeType;
